/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationFilters extends models.RecommendationFilterBase {
    getFixupPrototypeFunction() { return ListRecommendationFilters.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationFilters>): ListRecommendationFilters {
        let obj = Object.assign(new ListRecommendationFilters(), model);
        ListRecommendationFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationFilters>): ListRecommendationFilters {
        if (!model) return null;
        return ListRecommendationFilters.newInstance(<ListRecommendationFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationFilters) {
        if (!obj) return;

        models.ListRecommendationFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationFilters): boolean {
        if (models.RecommendationFilterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ListRecommendationFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.policy_classifications) {
            models.PolicyClassificationWithSubClassifications.fixupPrototype(this.policy_classifications);
        }
    }

    /**
     * Policy classification with sub-classifications.
     */
    policy_classifications: models.PolicyClassificationWithSubClassifications;

    /**
     * List of policy ids to get the recommendations.
     */
    policy_ids: Array<string>;

    /**
     * List of resource ids to get the recommendations.
     */
    resource_ids: Array<string>;

    /**
     * List of resource types to get the recommendations.
     */
    resource_types: Array<string>;

    /**
     * List of resources to get the recommendations.
     */
    resources: Array<string>;

    /**
     * List of cloud service name
     */
    service_names: Array<models.CloudServiceName>;

    /**
     * List of recommendation source to filter the recommendations.
     */
    sources: Array<models.RecommendationSource>;

    /**
     * List of recommendation status to filter the recommendations.
     */
    statuses: Array<models.PolicyResourceRecommendationStatus>;

}
